module.exports = __webpack_public_path__ + "img/Robot.6255b15b.png";